<template>
  <v-btn
    v-show="!showFilterPanel"    
    depressed
    @click="showFilterPanel = !showFilterPanel"
  >
    <v-icon
      small
    >mdi-menu</v-icon>{{$vuetify.breakpoint.mdAndDown ? '' : 'Vis filter'}}
  </v-btn>
</template>

<script>
import { mapActions } from 'vuex';
export default {
  name: "FilterDrawerToggle",
  computed: {
    showFilterPanel: {
      set (showFilterPanel) {
        this.setShowFilterPanel(showFilterPanel);
      },
      get () {
        return this.$store.state.showFilterPanel;
      }
    }
  },
  methods: {
      ...mapActions(["setShowFilterPanel"])
  }
}
</script>

<style>
</style>